import React from "react";
import "./about.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/Hardsell.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281325283186&text=Halo%20Reza,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Wisata%20(About)%20https://perumahankotawisata.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="about">
      <div id="about" className="container-about">
        <h1>Kota Wisata A Home That Has Everything</h1>
        <div className="container-desk">
          <div className="desk">
            Kota Wisata Cibubur adalah sebuah kawasan hunian terpadu (township)
            yang berlokasi di Cibubur. Dikembangkan oleh Sinar Mas Land, Kota
            Wisata Cibubur menawarkan perumahan dengan konsep tematik yang
            terinspirasi dari berbagai kota dunia, seperti Paris, Amsterdam, dan
            San Francisco. Kota Wisata Cibubur dikenal sebagai kawasan hunian
            modern dengan lingkungan hijau dan berbagai fasilitas yang menunjang
            gaya hidup urban. Kota Wisata juga menawarkan berbagai promo menarik
            untuk para calon penghuninya.
          </div>
        </div>
        <div id="promo" className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Siap Huni
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free DP
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free PPN
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Biaya KPR
              </span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Smart Door Lock
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Smarthome System
              </span>
            </div>
          </div>
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Lift
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free CCTV
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Canopy
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Solar Panel
              </span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Instan Approval
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#9a7438" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Cicilan Start 6 Juta/Bulan
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
    </div>
  );
};

export default About;
